<template>
  <div class="trainLeavePage" v-if="!showLoad">
    <van-cell-group class="baseNone baseSalary">
      <van-field
        :value="
          leaveInput.applicantIdName
            ? leaveInput.applicantIdName
            : leaveInput.applicantName
        "
        v-if="mode != 'add'"
        :required="editType"
        readonly
        label="申请人："
        class="ggInput"
      />
      <van-field
        v-model="userinfo.realName"
        v-else
        :required="editType"
        readonly
        label="申请人："
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary moreText">
      <van-field
        label="培训课程名称："
        v-model="leaveInput.courseName"
        :required="editType"
        :readonly="!editType"
        :placeholder="editType ? '请输入...' : ''"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary moreText">
      <van-field
        label="培训性质："
        v-model="leaveInput.nature"
        :required="editType"
        :readonly="!editType"
        :placeholder="editType ? '请输入...' : ''"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary moreText">
      <van-field
        label="培训日期："
        v-model="leaveInput.trainingDate"
        :required="editType"
        readonly
        @click="TimePicker('peixun')"
        :is-link="editType"
        :placeholder="editType ? '请选择' : ''"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary moreText">
      <van-field
        label="请假开始时间："
        :required="editType"
        readonly
        v-model="leaveInput.startTime"
        @click="TimePicker('start')"
        :is-link="editType"
        :placeholder="editType ? '请选择' : ''"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary moreText">
      <van-field
        label="请假结束时间："
        :required="editType"
        readonly
        v-model="leaveInput.endTime"
        @click="TimePicker('end')"
        :is-link="editType"
        :placeholder="editType ? '请选择' : ''"
        class="ggInput"
      />
    </van-cell-group>

    <van-cell-group class="baseNone beizhu">
      <van-field
        v-model="leaveInput.reason"
        rows="1"
        autosize
        :required="editType"
        label="请假原因："
        type="textarea"
        :placeholder="editType ? '请输入...  ' : ''"
        :readonly="!editType"
      />
    </van-cell-group>

    <!-- 审批流程 -->
    <div
      class="approveList"
      v-if="mode !== 'add' && leaveInput.verifyStatus != 'hold'"
    >
      <audit-list :applicantData="leaveInput"></audit-list>
    </div>

    <!-- 流程图 -->
    <div
      class="flowList"
      v-if="mode !== 'add' && leaveInput.verifyStatus != 'hold'"
    >
      <flow-staff :applicantData="leaveInput"></flow-staff>
      <flow-list :workflowCode="leaveInput.workflowCode"></flow-list>
    </div>
    <!-- 审批 -->
    <van-popup
      v-model="verifyPageType"
      closeable
      round
      close-icon="close"
      position="bottom"
      class="verifyPage"
    >
      <verify-main
        :applicantData="leaveInput"
        @changeVerifyType="setVerifyType"
      ></verify-main>
    </van-popup>
    <!-- 保存按钮 -->

    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode == 'add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput('add')"
        >提交</van-button
      >
    </div>
    <!-- 编辑状态下 -->
    <template v-else-if="editType && mode != 'verify'">
      <div
        class="btnBox editBtnbox clearfix"
        v-if="leaveInput.verifyStatus == 'hold'"
      >
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="delApply"
              >删除</van-button
            >
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="checkInput('edit')"
              >保存</van-button
            >
          </van-col>
        </van-row>
      </div>
      <div
        class="btnBox denyBtn clearfix"
        v-if="leaveInput.verifyStatus == 'deny' && mode != 'verify'"
      >
        <van-button
          type="info"
          :loading="btnLoading"
          :loading-text="loadingText"
          @click="checkInput('edit')"
          >再次提交</van-button
        >
      </div>
    </template>
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        leaveInput.verifyStatus == 'pending' &&
        mode != 'verify' &&
        sendType != '1'
      "
    >
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="delApply"
        >撤回修改</van-button
      >
    </div>
    <!-- 审批按钮 -->
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        (mode == 'verify' &&
          leaveInput.verifyStatus == 'pending' &&
          verifyType == '1') ||
        (mode == 'verify' &&
          leaveInput.verifyStatus == 'doing' &&
          verifyType == '1')
      "
    >
      <van-button type="info" @click="verifyPage">审批</van-button>
    </div>
    <!-- 弹框 -->

    <!-- 时间控件 -->
    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        @cancel="showTimePicker = false"
        @confirm="onTimeConfirm"
        :min-date="minDate"
      />
    </van-popup>

    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/* eslint-disable */
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
const refreshPage = () => import("@/components/common/refreshPage");
const fileView = () => import("@/components/common/fileView");
const wxFileView = () => import("@/components/common/wxFileView");
const flowList = () => import("@/components/common/flowList");
const auditList = () => import("@/components/common/auditList");
const verifyMain = () => import("@/components/common/verifyMain");
const flowStaff = () => import("@/components/common/flowStaff");
import {
  getCurData,
  dateTimeFormat,
  getDictList,
  intervalTime,
  diffMonth,
  isEdit,
} from "@/utils/common";
import {
  getDeviceType,
  closePage,
  is_wei,
} from "@/common/getDeviceType/getDeviceType";
export default {
  name: "trainLeaveApply",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      leaveInput: {
        id: "",
        applicantId: "", //申请人id
        applicantName: "", //申请人姓名
        courseName: "", //课程Name

        startTime: "", //请假开始时间
        endTime: "", //请假结束时间
        trainingDate: "", //培训日期
        reason: "", //原因
        verifyStatus: "hold", //详情的当前状态
        baseAnnexes: [], //附件
      },
      mode: "add",
      commonId: "", //编辑Id
      editType: false, //当前表单是否可以编辑

      showTimePicker: false, //时间控件
      currentDate: new Date(), //当前时间
      minDate: new Date(new Date(new Date().toLocaleDateString()).getTime()),
      checkIndex: "", // 获取请假开始和结束时间
      verifyPageType: false, //审批弹框,默认不显示
      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      refreshPage: false, // 网络请求失败时显示
      sendType: "", //判断是否在抄送列表
      clientType: getDeviceType(), //手机类型
      is_weixn: is_wei(), //是否为微信
    };
  },
  mounted() {
    if (is_wei()) {
      document.title = "培训请假申请";
    }

    window.editPage = this.editPage; //编辑页面
    this.verifyType = this.$route.query.verifyType; //审核状态是否已审核
    this.commonId = this.$route.query.commonId; //申请Id
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑 verify 审批
    this.sendType = this.$route.query.sendType; // 1：在抄送列表
    this.$nextTick(function () {
      this.editType = this.mode == "add" ? true : false;
      this.setShowLoad(false); //加载状态，默认为true加载
      if (this.userinfo && this.userinfo.id) {
        this.leaveInput.applicantName =
          this.mode == "add" ? this.userinfo.realName : "";
        this.leaveInput.applicantId =
          this.mode == "add" ? this.userinfo.id : "";
      }
      this.mode !== "add" ? (this.commonId ? this.getDetails() : "") : "";
    });
  },
  components: {
    refreshPage,
    fileView,
    wxFileView,
    auditList,
    flowList,
    verifyMain,
    flowStaff,
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    editPage() {
      //app调用编辑
      this.editType = true;
    },
    verifyPage() {
      //app调用审批
      this.verifyPageType = true;
    },

    /*获取详情*/
    getDetails() {
      let _this = this;

      _this.$api.userCenter.user.trainLeave
        .details(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.leaveInput = newApi.assign({}, _this.leaveInput, res.data);
            if (
              (_this.leaveInput.verifyStatus == "hold" ||
                _this.leaveInput.verifyStatus == "deny") &&
              _this.mode == "edit"
            ) {
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          let text = "网络失败，请稍后重试";
          closePage(text);
        });
    },
    //

    /*获取时间控件*/
    TimePicker(type) {
      if (this.editType) {
        this.checkIndex = type;
        this.showTimePicker = true;
      }
    },
    /*获取时间数据*/
    onTimeConfirm(data) {
      this.showTimePicker = false;
      if (this.checkIndex == "peixun") {
        this.leaveInput.trainingDate = dateTimeFormat(data);
      } else if (this.checkIndex == "start") {
        this.leaveInput.startTime = dateTimeFormat(data);
      } else {
        this.leaveInput.endTime = dateTimeFormat(data);
      }
    },

    //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
    /*提交表单*/
    checkInput(msg) {
      let _this = this;
      console.log(_this.leaveInput);
      /*校验*/
      if (
        _this.leaveInput.applicantId &&
        _this.leaveInput.courseName &&
        _this.leaveInput.endTime &&
        _this.leaveInput.nature &&
        _this.leaveInput.startTime &&
        _this.leaveInput.trainingDate &&
        _this.leaveInput.reason
      ) {
        _this.mode = msg;
        _this.saveAll();
      } else {
        _this.$toast("带星号为必填，不能为空");
      }
    },
    /*保存接口*/
    saveAll() {
      let _this = this;
      _this.btnLoading = true;
      _this.$api.userCenter.user.trainLeave
        .addApply(_this.mode, _this.leaveInput)
        .then((res) => {
          if (res.code == "1") {
            let text = this.mode == "add" ? "添加成功" : "编辑成功";
            closePage(text);
          } else {
            // console.log(res.msg);
            _this.$toast(res.msg);
          }
          _this.btnLoading = false;
        })
        .catch((err) => {
          console.log(err);
          _this.btnLoading = false;
          _this.$toast("网络失败，请稍后重试");
        });
    },
    /*撤回/删除*/
    delApply() {
      let _this = this;
      let msg = _this.leaveInput.verifyStatus == "hold" ? "删除" : "撤回";
      _this.$dialog
        .confirm({
          title: "确认" + msg,
          message: "您确认要" + msg + "当前申请?",
        })
        .then(() => {
          _this.btnLoading = true;
          _this.$api.userCenter.user.trainLeave
            .delApply(_this.leaveInput.verifyStatus, _this.leaveInput.id)
            .then((res) => {
              if (res.code == "1") {
                let text = msg + "操作成功";
                closePage(text);
              } else {
                _this.$toast(res.msg);
                console.log(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch((err) => {
              _this.btnLoading = false;
              _this.$toast("网络失败，请稍后重试");
            });
        });
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
  watch: {
    userinfo: {
      handler: function () {
        if (this.userinfo && this.userinfo.id) {
          this.leaveInput.applicantName =
            this.mode == "add" ? this.userinfo.realName : "";
          this.leaveInput.applicantId =
            this.mode == "add" ? this.userinfo.id : "";
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.trainLeavePage {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  padding-top: 12px;

  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.moreText {
    .van-cell {
      .van-cell__title {
        width: 160px;
      }
    }
  }
  .baseNone.moreLeaveText {
    .van-cell {
      .van-cell__title {
        width: 200px;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }

  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin-top: 10px;
  }
  //审批操作样式
}
</style>